import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '@service/alert.service';
import { AuthService } from '@service/auth.service';
import { BrokrageService } from '@service/brokrage.service';
import { CountryISO } from "@shared/module/ngx-tel-input/enums/country-iso.enum";

@Component({
  selector: 'app-finvasia',
  templateUrl: './finvasia.component.html',
  styles: [
  ]
})
export class FinvasiaComponent implements OnInit {

  finvasiaForm: FormGroup;
  isLoggedIn: boolean = false
  CountryISO = CountryISO;
  constructor(
    private matDialogRef: MatDialogRef<FinvasiaComponent>,
    private fb: FormBuilder,
    private brokrageService: BrokrageService,
    private authService: AuthService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.authService.isLoggedIn.subscribe((res) => this.isLoggedIn = res)
    this.initializeForm();
  }
  
  initializeForm(){
    this.finvasiaForm = this.fb.group({
      uid : ['', Validators.required],
      otp: ['',Validators.required],
      password: ['', Validators.required]
    })
  }
  onSubmitForm(){
    const data = { 
      uid: this.finvasiaForm.value.uid,
      otp: this.finvasiaForm.value.otp,
      password: this.finvasiaForm.value.password
    };
    if(this.isLoggedIn){
      this.finvasiaLogin(data)
    }else {
      this.brokrageService.finvasiasignIn(data).subscribe({
        next: (res: any) => {
          this.matDialogRef.close({ app: data, data: res.data });
          this.alertService.success('Finvasia login Successfull')
        }
      });    
    }
  }

  finvasiaLogin(data) {
    this.brokrageService.finvasiaLogIn(data).subscribe({
        next: (res) => {
            this.alertService.success('Finvasia login Successfull')
            this.authService.UpdateUserData(false)
            this.matDialogRef.close(true)
        }
    })
  }
  closeDialog() {
    this.matDialogRef.close();
  }
}
